import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type Lightbulb2FillProps = IconComponentBaseProps;

export const Lightbulb2Fill = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: Lightbulb2FillProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_10823_75797"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_10823_75797)">
        <path
          d="M8.33335 15C7.87502 15 7.48266 14.8368 7.15627 14.5104C6.82988 14.184 6.66669 13.7917 6.66669 13.3334V12.2917C5.87502 11.75 5.26044 11.0556 4.82294 10.2084C4.38544 9.36113 4.16669 8.45835 4.16669 7.50002C4.16669 5.87502 4.73266 4.49655 5.8646 3.3646C6.99655 2.23266 8.37502 1.66669 10 1.66669C11.625 1.66669 13.0035 2.23266 14.1354 3.3646C15.2674 4.49655 15.8334 5.87502 15.8334 7.50002C15.8334 8.45835 15.6146 9.35766 15.1771 10.1979C14.7396 11.0382 14.125 11.7361 13.3334 12.2917V13.3334C13.3334 13.7917 13.1702 14.184 12.8438 14.5104C12.5174 14.8368 12.125 15 11.6667 15H8.33335ZM8.33335 18.3334C8.09724 18.3334 7.89933 18.2535 7.7396 18.0938C7.57988 17.934 7.50002 17.7361 7.50002 17.5V16.6667H12.5V17.5C12.5 17.7361 12.4202 17.934 12.2604 18.0938C12.1007 18.2535 11.9028 18.3334 11.6667 18.3334H8.33335Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
